<template>
  <div class="results-list__item__row">
    <!-- REFACTOR_CHECK: Only differences per block are pillClass, review text and count -->
    <div v-if="this.score >= 9" class="results-list__item__score">
      <span class="pill--dark-green u-border-radius--tiny">{{ score }}</span>
      <span class="u-weight--bold">{{ $t("reviews.reallyGood") }}</span>
      ({{ $t("reviewCount", getReviewCount()) }})
    </div>

    <div v-else-if="this.score > 7" class="results-list__item__score">
      <span class="pill--green u-border-radius--tiny">{{ score }}</span>
      <span class="u-weight--bold">{{ $t("reviews.good") }}</span> ({{
        $t("reviewCount", getReviewCount())
      }})
    </div>

    <div v-else-if="this.score >= 6" class="results-list__item__score">
      <span class="pill--orange u-border-radius--tiny">{{ score }}</span>
      <span class="u-weight--bold">{{ $t("reviews.average") }}</span> ({{
        $t("reviewCount", getReviewCount())
      }})
    </div>

    <div v-else-if="this.score >= 1" class="results-list__item__score">
      <span class="pill--red u-border-radius--tiny">{{ score }}</span>
      <span class="u-weight--bold">{{ $t("reviews.bad") }}</span> ({{
        $t("reviewCount", getReviewCount())
      }})
    </div>

    <div v-else class="results-list__item__score">
      <span class="pill--grey u-border-radius--tiny">{{ score }}</span>
      <span class="u-weight--bold">{{ $t("noReviews") }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Reviews",
  props: {
    score: Number,
    amount: Number
  },
  methods: {
    getReviewCount() {
      const reviewCount = this.formatNumber(this.amount);
      return { count: this.amount, numberOfReviews: reviewCount };
    }
  }
};
</script>
